import React, { useState } from 'react';

import { Box, Button } from '@mui/material';

import { Textfield } from 'components/Form';
import Layouts from 'layouts';

import { HOME_ROUTE } from 'routes/core/RouterConstants';
import LocaleStorageService from 'services/LocaleStorageService';

const LoginPage = () => {
  const [key, setKey] = useState('');

  const handleSetKey = () => {
    LocaleStorageService.set('key', key);
    window.location.href = HOME_ROUTE;
  };

  const handleOnChange = (event) => {
    const value = event.target.value;
    LocaleStorageService.set('key', value);
    setKey(value);
  };

  return (
    <Layouts.Flexbox
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      pt="200px"
    >
      <Layouts.Flexbox alignItems="center" gap="0 20px">
        <Box>
          <Textfield
            name="key"
            placeholder="secret key"
            sx={{ width: '350px' }}
            value={key}
            onChange={handleOnChange}
          />
        </Box>
        <Box>
          <Button
            size="medium"
            color="success"
            variant="outlined"
            onClick={handleSetKey}
          >
            Login
          </Button>
        </Box>
      </Layouts.Flexbox>
    </Layouts.Flexbox>
  );
};

export default LoginPage;
